import { Grid, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import type { ProductFormState } from "./editProduct/ProductEdit";
import ProductEdit from "./editProduct/ProductEdit";
import { useCreateProduct } from "./useCreateProduct";
import { useForm } from "react-hook-form";

const NewProductPage = () => {
  const navigate = useNavigate();
  const { createProduct } = useCreateProduct();
  const { control, handleSubmit, watch } = useForm<ProductFormState>({
    defaultValues: {
      name: "",
      currency: "PLN",
      info: { external: "", internal: "" },
      description: {
        polish: "",
        english: "",
      },
      productsGroup: "",
      taxNo: "",
      bankAccount: "",
      contact: { address: "", email: "", googlePlaceId: "" },
      provider: { id: undefined, useDynamicPrices: false },
      images: [],
    },
    mode: "onBlur",
  });
  const productName = watch("name");
  const providerId = watch("provider.id");
  const submitDisabled = !productName || !providerId;

  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
      }}
    >
      <ProductEdit control={control} providerId={providerId} />
      <Grid
        size={12}
        container
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <Stack direction="row" spacing={2}>
          <CancelButton onClick={() => navigate("/admin/products")} />
          <AsyncLoadingButton
            variant="outlined"
            color="primary"
            disabled={submitDisabled}
            onClick={handleSubmit(
              async ({
                name,
                provider,
                currency,
                info,
                description,
                taxNo,
                bankAccount,
                productsGroup,
                contact,
                images,
              }) => {
                const { id } = await createProduct({
                  name,
                  provider: {
                    id: provider.id,
                  },
                  currency,
                  info: {
                    external: info.external ? info.external : undefined,
                    internal: info.internal ? info.internal : undefined,
                  },
                  description,
                  taxNo: taxNo ? taxNo : undefined,
                  bankAccount: bankAccount ? bankAccount : undefined,
                  productsGroup: productsGroup ? productsGroup : undefined,
                  contact: {
                    address: contact.address ? contact.address : undefined,
                    email: contact.email ? contact.email : undefined,
                    googlePlaceId: contact.googlePlaceId ? contact.googlePlaceId : undefined,
                  },
                  images,
                });
                navigate(`/admin/products/${id}`);
              },
            )}
          >
            Zapisz
          </AsyncLoadingButton>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NewProductPage;
